import { render } from "./AwaitingApproval.vue?vue&type=template&id=0c24cd72"
import script from "./AwaitingApproval.vue?vue&type=script&lang=js"
export * from "./AwaitingApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__